import Vue from 'vue';
const EventBus = new Vue();
import CheckinPrevent from '@/components/CheckinPrevent';
import RecognisePerson from '@/components/RecognisePerson';

export const EmitPreventCheckin = (data) => {
  EventBus.$emit('OPEN_MODAL', {
    config: {
      closeButton: false,
      classes: 'message is-danger'
    },
    vue: {
      component: CheckinPrevent,
      props: data
    }
  });
}

export const EmitCloseModal = () => {
  EventBus.$emit('CLOSE_MODAL');
}

export const EmitRecognisePerson = data => {
  return new Promise(resolve => {
    EventBus.$emit('OPEN_MODAL', {
      config: {
        closeButton: false,
        classes: 'message is-success'
      },
      vue: {
        component: RecognisePerson,
        props: {
          contact: data || {}
        },
        listeners: {
          render(component) {
            if (component) resolve(component)
          }
        }
      }
    });
  })
}

export default EventBus;